module.exports = () => ({
  ".tig-heading": {
    "@apply ds-text-4xl ds-leading-lg ds-pb-xl sm:!ds-text-6xl sm:!ds-leading-3xl md:ds-pb-2xl ds-text-center ds-max-w-[720px] ds-m-auto": 1,
    overflowWrap: "anywhere",
  },

  ".tig-item": {
    "@apply ds-relative ds-w-full ds-h-auto ds-flex ds-flex-col ds-gap-y ds-mx-auto": 1,
    "& > *": { "@apply ds-relative": 1 },
    "&::before": { "@apply ds-content-[''] ds-absolute ds-inset-0": 1 },

    ".tig-item-icon": {
      "@apply ds-shrink-0 ds-bg-background-white ds-rounded-full ds-flex ds-self-center": 1,
      "& > :first-child": { "@apply ds-m-auto ds-bg-center ds-bg-no-repeat ds-bg-cover": 1 },
    },
    ".tig-item-icon-balance": { "@apply ds-hidden": 1 },

    ".tig-item-content": {
      "@apply ds-flex ds-flex-col ds-w-full ds-h-full ds-box-content ds-max-w-[760px]": 1,
      "&-heading": { overflowWrap: "anywhere" },
      "&-text": { "@apply ds-base-editor-text ds-grow": 1 },
      "&-text:not(:last-child)": { "@apply ds-pb-xl sm:!ds-pb": 1 },
    },
  },

  ".tig-item.tig-4": {
    "@apply ds-px-xl ds-pb-xl lg:!ds-px-xl lg:!ds-pb-xl": 1,
    "&::before": { "@apply ds-top-[55px] md:!ds-top-[68px]": 1 },

    ".tig-item-icon": {
      "@apply ds-w-[100px] ds-h-[100px] md:!ds-h-[125px] md:!ds-w-[125px]": 1,
      "& > :first-child": { "@apply ds-w-[65px] ds-h-[65px] md:!ds-w-[75px] md:!ds-h-[75px]": 1 },
    },

    ".tig-item-content": {
      "&-heading": { "@apply ds-text-lg ds-leading-sm sm:!ds-text-2xl sm:!ds-leading-base ds-pb-xl": 1 },
      "&-text": { "@apply ds-text-base ds-leading-base": 1 },
    },
  },

  ".tig-item.tig-3": {
    "@apply ds-px-xl ds-pb-xl lg:!ds-px-2xl lg:!ds-pb-2xl": 1,
    "&::before": { "@apply ds-top-[55px] md:!ds-top-[82px]": 1 },

    ".tig-item-icon": {
      "@apply ds-w-[100px] ds-h-[100px] md:!ds-w-[150px] md:!ds-h-[150px]": 1,
      "& > :first-child": { "@apply ds-w-[65px] ds-h-[65px] md:!ds-w-[85px] md:!ds-h-[85px]": 1 },
    },

    ".tig-item-content": {
      "&-heading": { "@apply ds-text-2xl ds-leading-base sm:!ds-text-4xl sm:!ds-leading-xl ds-pb-xl": 1 },
      "&-text": { "@apply ds-text-base ds-leading-base": 1 },
    },
  },

  ".tig-item.tig-2": {
    "@apply ds-px-xl ds-pb-xl lg:!ds-px-3xl lg:!ds-pb-3xl": 1,
    "&::before": { "@apply ds-top-[55px] md:!ds-top-[82px]": 1 },

    ".tig-item-icon": {
      "@apply ds-w-[100px] ds-h-[100px] md:!ds-w-[150px] md:!ds-h-[150px]": 1,
      "& > :first-child": { "@apply ds-w-[65px] ds-h-[65px] md:!ds-w-[85px] md:!ds-h-[85px]": 1 },
    },

    ".tig-item-content": {
      "&-heading": { "@apply ds-text-2xl ds-leading-base sm:!ds-text-4xl sm:!ds-leading-xl ds-pb-xl": 1 },
    },
  },

  ".tig-item.tig-1": {
    "@apply ds-gap-y sm:!ds-gap-y-xl lg:!ds-flex-row lg:!ds-justify-center": 1,
    "@apply ds-w-full ds-px-xl ds-pb-xl sm:!ds-px-3xl sm:!ds-pb-3xl md:!ds-pb-4xl": 1,
    "&::before": { "@apply ds-top-[55px] sm:!ds-top-[91px] lg:!ds-top-[105px]": 1 },

    ".tig-item-icon": {
      "@apply ds-w-[100px] ds-h-[100px] sm:!ds-w-[165px] sm:!ds-h-[165px] lg:!ds-w-[190px] lg:!ds-h-[190px] lg:!ds-order-1 lg:!ds-self-start": 1,
      "& > :first-child": {
        "@apply ds-w-[65px] ds-h-[65px] sm:!ds-w-[95px] sm:!ds-h-[95px] lg:!ds-w-[110px] lg:!ds-h-[110px]": 1,
      },
    },
    ".tig-item-icon-balance": { "@apply lg:!ds-block lg:!ds-basis-[190px] lg:!ds-shrink-[10]": 1 },

    ".tig-item-content": {
      "@apply lg:!ds-mt-[193px]": 1,
      "&-heading": { "@apply ds-text-4xl ds-leading-lg ds-pb-xl sm:!ds-text-6xl sm:!ds-leading-3xl": 1 },
    },
  },

  ".tig-theme-grey": { ".tig-item::before": { "@apply ds-bg-background-grey": 1 } },
  ".tig-theme-blue": { ".tig-item::before": { "@apply ds-bg-background-blue": 1 } },

  /** Used in TinyMCE editor for text-icon-group */
  ".tig-item-editor": {
    "@apply ds-base-editor-text": 1,
    "@apply ds-base-editor-padding": 1,
    "@apply ds-box-content ds-max-w-[760px]": 1,
  },
});
